import { useEffect, useState } from 'react';
import { useMeasureNew } from 'utilities/hooks/use-measure-new';

export const useYouTubePlayerVisibility = () => {
  const [mapContainer, setMapContainer] = useState<HTMLDivElement | null>(null);
  const bounds = useMeasureNew(mapContainer);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (bounds?.width && bounds?.width < 5) {
      setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  }, [bounds?.width]);

  return [setMapContainer, isVisible] as const;
};
